<!-- tabindex (and outline: none) needed to set focus on this div and receive events-->
<div class="sidebar" [class.loading]="(indicatorStatus$ | async) === EIndicatorStatus.LOADING"
     #sidebar
     tabindex="0"
     (keydown.arrowUp)="onKeyDownEvent($event)"
     (keydown.arrowDown)="onKeyDownEvent($event)">

    <div class="sort-container" *ngIf="workflowLayoutItems.length > 0 && sortOptions.length > 0">

        <div class="popout-button">
            <nuc-button-secondary text="Sort"
                                  [disabled]="(indicatorStatus$ | async) === EIndicatorStatus.LOADING"
                                  iconPosition="start"
                                  icon="nucicon_selector"
                                  [nucTooltip]="tableSortOptions.columns[0]?.title"
                                  [matMenuTriggerFor]="menu">
            </nuc-button-secondary>

            <mat-menu #menu="matMenu" class="menu-items-container">
                <button mat-menu-item
                        *ngFor="let sortOption of sortOptions"
                        (click)="onSortPropertyChanged(sortOption.getValue())"
                        [ngClass]="{'selected-option': tableSortOptions.columns[0]?.sortProperty === sortOption.getValue()}"
                        [disableRipple]="true">
                    {{ sortOption.getTitle() }}
                </button>
            </mat-menu>
        </div>

        <nuc-button-secondary [icon]="tableSortOptions.sortOrder === 'asc' ? 'nucicon_sort_asc' : 'nucicon_sort_dsc'"
                              [nucTooltip]="tableSortOptions.sortOrder === 'asc' ? 'Sort ascending' : 'Sort descending'"
                              [disabled]="(indicatorStatus$ | async) === EIndicatorStatus.LOADING"
                              (click)="onSortOrderChanged()">
        </nuc-button-secondary>
    </div>

    <div class="items-container" scrollIntoView>
        <ng-container *ngFor="let row of workflowLayoutItems; index as index">
            <nuc-media-card-view
                (click)="setSelectedWorkflowLayoutItem(row)"
                [isSelected]="(publicationItemSelectionService.selectedWorkflowLayoutItem$ | async)?.index === row.index"
                [media]="row.media"
                itemWidth="128">
                <div content>
                    {{ row.title }}
                </div>
            </nuc-media-card-view>
        </ng-container>

        <nuc-button-secondary text="Show more"
                              *ngIf="hasNext"
                              (click)="getPublicationItems()"
                              [disabled]="!hasNext || (indicatorStatus$ | async) === EIndicatorStatus.LOADING">
        </nuc-button-secondary>
    </div>
</div>
<rl-loading-indicator *ngIf="(indicatorStatus$ | async) === EIndicatorStatus.LOADING"></rl-loading-indicator>
